import EditTruck from "./EditTruck";

export default EditTruck;
